import React from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Swal from "sweetalert2";

import "./AddVehicleDrawer.css";
import { useSelector } from "react-redux";
import { addVehicle } from "../../redux/AdminReducer";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { bookeVehicle } from "../../redux/CustomerReducer";
const AddVehicleDrawer = (props) => {
  const dispatch = useDispatch();
  const vehicleData = useSelector(
    (state) => state?.AdminReducer?.allVehiclesData
  );

  console.log("props.driverData", props.driverData);

  const [vehicle, setVehicle] = useState({
    catagory: "",
    company: "",
    passenger: "",
    luggage: "",
    price: "",
    hourPrice: "",
    availability: false,
  });

  const[showDrivers,setShowDrivers]=useState(false);

  const [imageVehicle, setImageVehicle] = useState();
  const[idDriver,setIdDriver]=useState();

  const[selectDriver,setSelectDriver]=useState("Select Driver")
  const handleChange = (e) => {
    const { name, value } = e.target;

    console.log("e...............", e);

    setVehicle({
      ...vehicle,
      [name]: value,
    });
  };
  const availabilityChange = (e) => {
    console.log("e...............", e);

    setVehicle({
      ...vehicle,
      availability: !vehicle.availability,
    });
  };

  const handleImage = (e) => {
    const selected1 = e.target.files[0];

    setImageVehicle(selected1);
  };

  console.log("vehicle", vehicle);

  const addBtnClicked = async () => {
    const data = new FormData();
    data.append("catagory", vehicle.catagory);
    data.append("company", vehicle.company);
    data.append("passenger", vehicle.passenger);
    data.append("luggage", vehicle.luggage);
    data.append("price", vehicle.price);
    data.append("availability", vehicle.availability);
    data.append("photo", imageVehicle);
    data.append("driverId", idDriver);
    data.append("driverEmail",selectDriver);
    data.append("hourPrice",vehicle.hourPrice);

    const response = await dispatch(addVehicle({ data, vehicleData }));

    console.log("response", response?.payload?.message);
    Swal.fire("Good", response?.payload?.message, "success");
  };


  const showDriversClicked=()=>{

    setShowDrivers(!showDrivers)

  }


  const driverSelectClicked=(data)=>{

    
    setSelectDriver(data?.email)
    setIdDriver(data?._id)
    setShowDrivers(!showDrivers)

  }

  return (
    <>
      {[false].map((expand) => (
        <Navbar key={expand} bg="light" expand={expand} className="mb-3">
          <Container fluid>
            {/* <Navbar.Brand href="#">Navbar Offcanvas</Navbar.Brand> */}
            {/* <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} /> */}

            <Navbar.Toggle
              aria-controls={`offcanvasNavbar-expand-${expand}`}
              className="btnAddVehicle"
            >
              Add vehicle
            </Navbar.Toggle>
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
              className="addVehicleDrawer"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  Add Vehicle
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <div className="mainAddVehicleDrawerFields">
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Image :</div>
                    <input
                      placeholder="Please Enter Catagory"
                      className="inputFieldAddVeh"
                      type="file"
                      name="catagory"
                      onChange={(e) => handleImage(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Catagory :</div>
                    <input
                      placeholder="Please Enter Catagory"
                      className="inputFieldAddVeh"
                      name="catagory"
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Company :</div>
                    <input
                      placeholder="Please Enter Company Name"
                      className="inputFieldAddVeh"
                      name="company"
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Passenger :</div>
                    <input
                      placeholder="Please Enter Passenger Capacity"
                      className="inputFieldAddVeh"
                      name="passenger"
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Luggage :</div>
                    <input
                      placeholder="Please Enter Luggage Capacity"
                      className="inputFieldAddVeh"
                      name="luggage"
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Price Per Mile:</div>
                    <input
                      placeholder="Please Enter Price"
                      className="inputFieldAddVeh"
                      name="price"
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Price Per Hour:</div>
                    <input
                      placeholder="Please Enter Price"
                      className="inputFieldAddVeh"
                      name="hourPrice"
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  {/* <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Select Driver :</div>
                    <div className="inputFieldAddVehTopSlc">
                      <div className="inputFieldAddVeh inputFieldAddVehDrivers"
                      onClick={showDriversClicked}
                      >{selectDriver}</div>
                    {showDrivers&&  <div className="selectCustomeizeDrivers">
                        {props?.driverData?.map((item)=>(
                          <div className="drinverTxtInd"
                          onClick={()=>driverSelectClicked(item)}
                          >{item?.email}</div>
                        ))}
                      </div>}
                    </div>
                  </div> */}
                  <div className="topCatagoryField topCatagoryFieldCheck">
                    <div className="catagoryTxtAddVeh">Availability :</div>
                    <label class="switch1">
                      <input
                        type="checkbox"
                        name="availability"
                        onChange={(e) => availabilityChange(e)}
                      />
                      <span class="slider1 round1"></span>
                    </label>
                  </div>
                  <div className="topCatagoryField topCatagoryFieldCheck">
                    <Navbar.Toggle
                      aria-controls={`offcanvasNavbar-expand-${expand}`}
                    >
                      <button className="cnclBtn">Cancel</button>
                    </Navbar.Toggle>

                    <Navbar.Toggle
                      aria-controls={`offcanvasNavbar-expand-${expand}`}
                    >
                      <button className="addBtn" onClick={addBtnClicked}>
                        Add
                      </button>
                    </Navbar.Toggle>
                  </div>
                </div>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
};

export default AddVehicleDrawer;
